import script from "./ContentWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./ContentWrapper.vue?vue&type=style&index=0&id=b3f73820&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f73820"]])

export default __exports__